export const searchFilter = (data: any[], search: string): any[] =>
  data.filter((product) => {
    let textContact = '';
    Object.keys(product).forEach((key) => {
      const itemSelected = product[key];
      if (
        typeof itemSelected === 'string' ||
        typeof itemSelected === 'number' ||
        typeof itemSelected === 'boolean'
      ) {
        textContact += ` ${itemSelected}`;
      } else if (typeof itemSelected === 'object' && itemSelected !== null) {
        textContact += Object.keys(itemSelected)
          .map((itemSelectedtext) => itemSelected[itemSelectedtext])
          .join(' ');
      }
    });
    return textContact.toLowerCase().includes(search.toLowerCase());
  });

export function applyFilter({
  inputData,
  comparator,
  filterName,
  filterStatus,
  callback,
}: {
  inputData: any[];
  comparator: (a: any, b: any) => number;
  filterName: string;
  filterStatus: string[];
  callback?: (data: any) => any;
}) {
  const stabilizedThis = inputData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    inputData = searchFilter(inputData, filterName);
  }

  if (filterStatus.length) {
    inputData = inputData.filter((product) => {
      const status = product.status ? 'Activo' : 'Desactivado';
      return filterStatus.includes(status);
    });
  }
  if (callback) {
    inputData = callback(inputData);
  }

  return inputData;
}
